// Telemetry panel: what the voice reports, read from the newest telemetry record
// once a frame (docs/contracts/audio-bridge.md § Telemetry).

import { defineFeature } from "../../../registry";
import { el, rpmOf } from "../dom";
import { strings } from "./strings";

export default defineFeature({
  id: "telemetry",
  title: strings.title,
  slot: "panel",
  order: 10,
  mount({ root, audio }) {
    const off = el("p", { class: "panel-note" }, strings.off);
    const list = el("dl", { class: "panel-values" });
    const cells = {} as Record<keyof typeof strings.rows, HTMLElement>;
    for (const [key, label] of Object.entries(strings.rows) as [keyof typeof strings.rows, string][]) {
      cells[key] = el("dd", { "data-telemetry": key });
      list.append(el("dt", {}, label), cells[key]);
    }
    root.append(off, list);

    let frame = 0;
    const tick = (): void => {
      const engine = audio.engine;
      const rec = audio.latest;
      off.hidden = engine !== null;
      list.hidden = engine === null;
      if (engine !== null && rec !== null) {
        const stats = engine.stats();
        cells.processor.textContent = audio.processor;
        cells.rpm.textContent = `${Math.round(rpmOf(rec.omega))} rpm`;
        cells.angle.textContent = `${((rec.theta * 180) / Math.PI).toFixed(1)}°`;
        cells.cycle.textContent = String(rec.cycle);
        cells.load.textContent = `${(stats.load * 100).toFixed(1)} %`;
        cells.batches.textContent = String(stats.batches);
        cells.stalls.textContent = String(stats.stalls);
      }
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  },
});
